// @flow
import { NotificationMessage, Sidebar, SidebarSection } from 'bench-internal-theme';
import { useQuery } from '@apollo/client';
import React from 'react';
import { WrappedSpinner } from 'spinner';

import { GET_LEDGER_ACCOUNT_V1, GET_LEDGER_ACCOUNT_V2 } from './queries';
import LedgerAccountSidebar from './LedgerAccountSidebar';
// $FlowFixMe - TS file
import { apolloV2Client } from '../../general-ledger/queries';
import { FeatureValue, useFeatureFlags } from '@bench/ff-client';
// $FlowFixMe - TS file
import { SplitFeatureFlags } from '../features';

type LedgerAccountSidebarContainerProps = {
  dismiss: () => any,
  ledgerAccountId: string,
};

const LedgerAccountSidebarContainer = ({
  dismiss,
  ledgerAccountId,
}: LedgerAccountSidebarContainerProps) => {
  const [featureState] = useFeatureFlags();
  const {
    featureContext: { features },
  } = featureState;

  const isAssignCategoryImprovementEnabled =
    features[SplitFeatureFlags.ASSIGN_CATEGORY_IMPROVEMENT]?.value === FeatureValue.FEATURE_ON;

  const query = isAssignCategoryImprovementEnabled ? GET_LEDGER_ACCOUNT_V2 : GET_LEDGER_ACCOUNT_V1;

  const { loading, error, data } = useQuery(query, {
    variables: { id: ledgerAccountId },
    client: apolloV2Client,
    context: isAssignCategoryImprovementEnabled ? { useV2: true } : undefined,
  });

  if (loading) {
    return (
      <Sidebar dismiss={dismiss} headerContent="">
        <WrappedSpinner />
      </Sidebar>
    );
  }

  if (error) {
    return (
      <Sidebar dismiss={dismiss} headerContent="">
        <SidebarSection>
          <NotificationMessage styleType="error">
            There was a problem loading the ledger info. The error was “{error.message}”
          </NotificationMessage>
        </SidebarSection>
      </Sidebar>
    );
  }

  return <LedgerAccountSidebar dismiss={dismiss} ledgerAccount={data.ledgerAccount} />;
};

export default LedgerAccountSidebarContainer;
